import React, { useEffect, useRef, useState } from 'react'
import ReactPlayer from 'react-player'
import "./style.css";

function SliderVideo({data}) {
    const ruta =[];
    const [rutavid, setRutasVid] = useState([]);
    const [myvideo, setMyvideo] = useState("");
    const myvideoIndex = useRef(0);

    const GenerarRutaArch = (Datos) => {
        const ItemId = Datos.ItemId;
        const ArchivoId = Datos.ArchivoId;
        const Formato = Datos.Formato;
        const NombreArch = ArchivoId + "_" + ItemId + "." + Formato;
        const RutaArch =  "/api/static/" + Datos.RutaArch + "/" + NombreArch;
        return RutaArch;
      };

    const playNext = () => {
        const nextIndex = myvideoIndex.current + 1
        if (nextIndex >= rutavid.length) {
          setMyvideo(rutavid[0])
          myvideoIndex.current=0;
        } else {
            setMyvideo(rutavid[nextIndex])
          myvideoIndex.current = nextIndex;
        }
      
    }

      useEffect(() => {
        data.forEach((item) => {
            const Ruta = GenerarRutaArch(item);
            ruta.push(Ruta);
        });  
        //console.log(ruta);
        setRutasVid(ruta);  
        setMyvideo(ruta[0]);
      }, []);
    
    return(<>
       <div className="slider">
            <div className="flex w-full h-full">
               <ReactPlayer url={myvideo}
                pip={true}
                controls={true}
                playing={true} 
                volume={0}
                muted={false}
                allowFullScreen
                onEnded={playNext} 
                width={'100%'}
                height={'28rem'}
                className='flex w-full h-full'/>  
            </div> 
        </div>      
    </>);
}
export default SliderVideo;